module.exports = {"name":"MapWidget","version":"2.4.5","description":"","repository":{"type":"git","url":"https://github.com/graylog-plugin-map-widget"},"scripts":{"build":"webpack --bail"},"keywords":["graylog"],"author":"Graylog, Inc. <hello@graylog.com>","license":"GPL-3.0","dependencies":{"leaflet":"^1.2.0","react-leaflet":"^1.6.0"},"devDependencies":{"graylog-web-plugin":"file:../graylog2-server/graylog2-web-interface/packages/graylog-web-plugin"}}


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 250
// module chunks = 0